import fx from 'money'
import React, { Component } from 'react'
import ReceiptsApi from '../../../../api/Sales/Receipts'
import { withRouter } from 'react-router-dom'
import { compose, withState } from 'recompose'
import { message, Select } from 'antd'
import { isEmpty, pick, set, sumBy } from 'lodash'
import { numVal, strVal } from '../../../../modules/Utils'
import AddReceipt from '../../../../components/Sales/Payments/AddReceipt/AddReceipt'
import TransactionsApi from '../../../../api/Finance/Transactions'

import InvoicesApi from '../../../../api/Sales/Invoices'

import moment from 'moment'
import SalesContractsApi from '../../../../api/Sales/SalesContracts'
import withUrlFetch from '../../../../elements/Select/withUrlFetch'
import withSpinning from '../../../../elements/HOC/withSpinning'
import withSort from '../../../../elements/HOC/withSort'
import CustomSelect from '../../../../elements/Select/CustomSelect'

class AddReceiptCont extends Component {
  constructor(props) {
    super(props)
    this.key = props.match.params.key
    this.state = {
      list: [],
      invoices: [],
      transaction: {},
      receipt: {},
      calculation: { allocated: 0, remaining: 0, total: 0, contract: 0 },
      fetching: false,
      visible: false,
      submitting: false,
      ContractsSelectCmp: Select,
    }
    this.api = new TransactionsApi()
    this.salesContractsApi = new SalesContractsApi()
    this.invoicesApi = new InvoicesApi()
    this.receiptsApi = new ReceiptsApi()
    this.formRef = React.createRef()
  }

  componentDidMount() {
    if (this.props.location.pathname.includes('deposit')) this.fetchContract()
    else this.fetchTransaction()
  }

  fetchContract = async () => {
    try {
      this.setState({
        visible: true,
        type: 'new',
        receiptType: 'deposit',
        fetchingTransaction: true,
      })
      const contract = await this.salesContractsApi.get(this.key)
      this.setState({
        fetchingTransaction: false,
        transaction: Object.assign({}, contract, {
          currency: strVal(contract, 'currency.pay.currency'),
        }),
      })
      this.onChangeContract(contract._id)
      this.onChangeClient(contract.client._id)
      this.formRef.current.setFieldsValue({
        'contract._id': contract._id,
        'client._id': contract.client._id,
      })
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      this.setState({ fetchingTransaction: false, visible: false })
    }
  }
  fetchTransaction = async () => {
    try {
      this.setState({
        visible: true,
        type: 'new',
        fetchingTransaction: true,
      })
      const transaction = await this.api.read(this.key)
      this.setState({
        fetchingTransaction: false,
        transaction,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ fetchingTransaction: false, visible: false })
    }
  }
  onShow = async (e, transaction) => {
    this.setState({
      visible: true,
    })
    await this.fetchTransaction(transaction._key)
  }
  onCancel = () => {
    this.setState({
      visible: false,
      transaction: {},
      invoices: [],
      receipt: {},
      calculation: { allocated: 0, remaining: 0, total: 0, contract: 0 },
    })
    this.formRef.current.resetFields()
  }
  onChangeContract = async (_id) => {
    if (!isEmpty(_id)) {
      try {
        this.setState({
          fetchingInvoices: true,
        })
        let oldInvoices = this.state.invoices.filter((invo) => invo.selected === true)

        const { transaction } = this.state

        console.log(_id, transaction._id)
        let invoices = await this.invoicesApi.unpaid(_id, transaction._id)
        invoices = invoices.filter((i) => !oldInvoices.find((inv) => inv._id === i._id))
        invoices = [...oldInvoices, ...invoices]

        const exchange = await this.invoicesApi.exchange(
          moment(strVal(this.state.transaction, 'date')).format('YYYY-MM-DD')
        )
        console.log({ exchange })
        fx.rates = exchange.rates
        fx.base = exchange.base

        const receiptCurrency = strVal(this.state.transaction, 'currency')

        invoices = invoices.map((i) => {
          const currency = strVal(i, 'currency')

          const rate = fx.convert(1, { from: currency, to: receiptCurrency })
          const gross = fx.convert(numVal(i, 'subTotal.gross'), { from: currency, to: receiptCurrency })
          const paid = fx.convert(numVal(i, 'paid'), { from: currency, to: receiptCurrency })
          const amount = fx.convert(numVal(i, 'amount'), { from: currency, to: receiptCurrency })
          console.log({ currency, receiptCurrency, rate, gross, paid, amount })

          return {
            ...i,
            converted: {
              currency: receiptCurrency,
              rate,
              gross,
              paid,
              amount,
            },
          }
        })

        const total = sumBy(invoices, (i) => numVal(i, 'converted.gross') - numVal(i, 'converted.paid'))
        const allocated = sumBy(invoices, (i) => numVal(i, 'converted.amount'))

        let calculation = { ...this.state.calculation }
        calculation.remaining = numVal(this.state, 'transaction.amount') - allocated - numVal(calculation, 'contract')
        calculation.total = total
        calculation.allocated = allocated
        this.setState({
          invoices,
          contract: _id,
          cachedInvoices: invoices,
          calculation,
          fetchingInvoices: false,
        })
      } catch (e) {
        message.error(e.errorMessage)
        this.setState({ fetchingInvoices: false })
      }
    }
  }
  onChangeClient = (client) => {
    if (!isEmpty(client)) {
      const owner = client.replace('partners/', '')
      const url = `clients/` + (isEmpty(owner) ? '' : `${owner}`) + `/contracts?state=active`
      const ContractsSelectCmp = compose(
        withUrlFetch({
          name: 'clients_contracts',
          url: url,
          cache: true,
        }),
        withSpinning,
        withSort
      )(CustomSelect)
      this.formRef.current.resetFields(['contract._id'])
      this.setState({ client, ContractsSelectCmp, url })
    } else {
      this.setState({
        client: '',
        ContractsSelectCmp: Select,
        url: '',
      })
    }
  }
  onChangeContractAllremoveocated = (value) => {
    this.setState((prevState, props) => {
      let calculation = prevState.calculation
      calculation.contract = numVal({ value }, 'value')
      calculation.remaining =
        numVal(prevState, 'transaction.amount') - (calculation.allocated + numVal({ value }, 'value'))
      return { calculation }
    })
  }
  submit = async () => {
    await this.checkForm()
    try {
      let { receipt, receiptType } = { ...this.state }
      receipt.transaction = pick(this.state.transaction, ['_id'])
      receipt.date = moment()
      const lines = { ...this.state }.invoices
        // .filter(
        //   (i) =>
        //     numVal(i, 'amount') > 0 ||
        //     numVal(i, 'discount') > 0 ||
        //     numVal(i, 'bankFees') > 0 ||
        //     numVal(i, 'exchangeLoss') > 0 ||
        //     numVal(i, 'wtax.tax') > 0
        // )
        .map((i) => ({
          ...pick(i, ['amount', 'discount', 'bankFees', 'exchangeLoss', 'converted']),
          invoice: pick(i, ['_id', '_rev', 'code', 'activity', 'date']),
          receipt: { _id: 'temp' },
        }))

      console.log(111, { lines })
      // TODO: Check if there are any problems with the removal of deposit check

      /*if (
        Math.round(this.state.calculation.remaining * 100) / 100 !== 0 &&
        receiptType !== 'deposit'
      ) {
        message.error('Make sure that remaining is equal to zero 0.')
        return
      }*/
      this.setState({
        submitting: true,
      })
      await this.receiptsApi.createWithLines({ doc: receipt, lines, receiptType })
      this.setState({
        submitting: false,
      })
      this.onCancel()
      message.success('Receipt Created')
      this.props.history.push({
        pathname: `/clients/payments/`,
        hash: 'receipts',
      })
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      this.setState({ submitting: false })
    }
  }
  checkForm = () => {
    return new Promise((res, rej) => {
      this.formRef.current.validateFields((err, values) => {
        if (!err) {
          this.setState({
            receipt: Object.assign({}, this.state.receipt, values),
          })
          res(true)
        }
      })
    })
  }
  invoicesOps = {
    cancel: (_key) => {
      let newData = [...this.state.invoices]
      let target = newData.find((item) => _key === item._key)
      if (target) {
        target = { ...this.state.cached.find((item) => _key === item._key) }
        delete target.editable
        if (Object.keys(target).length === 1 && Object.keys(target)[0] === '_key') this.remove(target._key)
        else this.setState({ invoices: newData })
      }
    },
    remove: (_key) => {
      let newData = [...this.state.invoices]
      newData = newData.filter((item) => _key !== item._key)
      const total = sumBy(newData, (i) => numVal(i, 'converted.gross') - numVal(i, 'converted.paid'))
      const allocated = sumBy(newData, (i) => numVal(i, 'converted.amount'))
      let calculation = { ...this.state.calculation }
      calculation.remaining = numVal(this.state, 'transaction.amount') - allocated - numVal(calculation, 'contract')
      calculation.total = total
      calculation.allocated = allocated
      this.setState({ invoices: newData, calculation })
    },
    edit: (_key) => {
      const newData = [...this.state.invoices]
      const target = newData.filter((item) => _key === item._key)[0]
      if (target) {
        target.editable = true
        this.setState({ invoices: newData })
      }
    },
    save: (_key) => {
      const newData = [...this.state.invoices]
      const target = newData.find((item) => _key === item._key)
      console.log(55, target)
      target.converted = {
        gross: target.subTotal.gross * target.converted.rate,
        paid: target.subTotal.paid * target.converted.rate,
        amount: target.subTotal.amount * target.converted.rate,
        rate: target.converted.rate,
      }

      if (target) {
        delete target.editable
        target.selected = true
        target.newBalance =
          numVal(target, 'converted.gross') -
          (numVal(target, 'amount') +
            numVal(target, 'converted.paid') +
            numVal(target, 'discount') +
            numVal(target, 'bankFees') +
            numVal(target, 'exchangeLoss') +
            numVal(target, 'wtax.tax'))
        const amount = numVal(this.state, 'transaction.amount')
        const allocated = sumBy(newData, (i) => numVal(i, 'amount'))
        let calculation = { ...this.state.calculation }
        calculation = {
          ...calculation,
          allocated,
          remaining: amount - (numVal(calculation, 'contract') + allocated),
        }
        this.setState({
          invoices: newData,
          calculation,
          cached: newData.map((i) => ({ ...i })),
        })
      }
    },
  }
  handleChange = (value, _key, column) => {
    const newData = [...this.state.invoices]
    const target = newData.find((item) => _key === item._key)
    if (target) {
      set(target, column, value)
      this.setState({ invoices: newData })
    }
  }

  render() {
    return (
      <AddReceipt
        {...this.state}
        {...pick(this, [
          'fetch',
          'fetchTransaction',
          'onChangeContract',
          'onChangeClient',
          'onChangeContractAllocated',
          'fetchReceipts',
          'onCancel',
          'onShow',
          'onEdit',
          'submit',
          'handleChange',
          'invoicesOps',
          'update',
          'formRef',
        ])}
      />
    )
  }
}

AddReceiptCont.propTypes = {}
AddReceiptCont.defaultProps = {}

export default compose(withRouter, withState('fetchingLines', 'fetchLines', false))(AddReceiptCont)
